<div class="cart-overlay" [class.open]="open" (click)="closePanel.emit()"></div>

<div class="cart-panel" [class.open]="open" role="dialog" aria-modal="true" aria-label="Your cart">
  <div class="cart-sheet">
    <div class="cart-sheet__top">
      <div class="cart-sheet__crumb">Home &gt; Cart</div>
      <div class="cart-sheet__title-row">
        <h2 class="cart-sheet__title">Your Cart</h2>
        <button type="button" class="cart-close" (click)="closePanel.emit()" aria-label="Close cart">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      @if (!authService.currentUser()) {
        <div class="cart-auth-notice" style="margin-top:0.75rem;">
          Sign in to manage your cart and checkout.
        </div>
      }
    </div>

    <div class="cart-sheet__body">
      @if (cartService.loading()) {
        <div style="grid-column:1/-1;">
          <app-book-loader size="full" label="Loading your cart…"></app-book-loader>
        </div>
      } @else if (cartService.cartItems().length === 0) {
        <div class="cart-empty-modern">
          <h3>Your cart is empty</h3>
          <p>Add books from the catalogue to get started.</p>
        </div>
      } @else {
        <div class="cart-sheet__list">
          @for (item of cartService.cartItems(); track item.CartId) {
            <article class="cart-row" @cartRowAnim>
              <div class="cart-row__thumb" [attr.aria-label]="item.BookTitle + ' cover'">
                <span aria-hidden="true">{{ item.BookTitle.slice(0, 2).toUpperCase() }}</span>
                @if (imageSrc(item.BookImageUrl); as src) {
                  <img [src]="src" [alt]="item.BookTitle" (error)="onImgError($event)" appImgFade />
                }
              </div>
              <div class="cart-row__meta">
                <h3 class="cart-row__title">{{ item.BookTitle }}</h3>
                <div class="cart-row__author">{{ item.BookAuthorName || 'Author' }}</div>
                <div class="cart-row__price">{{ formatPrice(item.CartLineTotal) }}</div>
              </div>
              <div class="cart-row__side">
                <button type="button" class="cart-row__remove" (click)="remove(item.CartId)" aria-label="Remove item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>
                </button>
                <div class="cart-row__qty">
                  <button type="button" (click)="updateQty(item.CartId, item.CartQty - 1)" aria-label="Decrease quantity">−</button>
                  <span>{{ item.CartQty }}</span>
                  <button type="button" (click)="updateQty(item.CartId, item.CartQty + 1)" aria-label="Increase quantity">+</button>
                </div>
              </div>
            </article>
          }
        </div>

        <aside class="cart-sheet__summary">
          <h3>Order Summary</h3>
          <div class="cart-sum-row">
            <span>Subtotal</span>
            <span>{{ formatPrice(total()) }}</span>
          </div>
          <div class="cart-sum-row cart-sum-row--discount">
            <span>Delivery Fee</span>
            <span>{{ deliveryFee() === 0 ? 'FREE' : formatPrice(deliveryFee()) }}</span>
          </div>
          <div class="cart-sum-divider"></div>
          <div class="cart-sum-total">
            <span>Total</span>
            <span>{{ formatPrice(grandTotal()) }}</span>
          </div>

          <button
            type="button"
            class="cart-checkout-btn btn-morph btn-gradient-motion"
            [class.is-loading]="paymentProcessing()"
            (click)="checkout()"
            [disabled]="paymentProcessing()"
            appRipple
          >
            @if (paymentProcessing()) {
              Processing…
            } @else {
              Go to Checkout →
            }
          </button>
          <button type="button" class="cart-clear-btn" (click)="clear()">Clear Cart</button>
        </aside>
      }
    </div>

    <div class="cart-news">
      <h4>Stay connected about our latest offers</h4>
      <form class="cart-news__form" (submit)="$event.preventDefault(); subscribeNewsletter()">
        <input
          type="email"
          name="newsletterEmail"
          placeholder="Enter your email"
          aria-label="Newsletter email"
          autocomplete="email"
          [value]="newsletterEmail()"
          (input)="newsletterEmail.set($any($event.target).value)"
        />
        <button type="submit" [disabled]="newsletterBusy()">
          {{ newsletterBusy() ? 'Subscribing…' : 'Subscribe to Newsletter' }}
        </button>
      </form>
    </div>
  </div>
</div>

@if (paymentProcessing()) {
  <div class="modal-overlay">
    <div class="modal payment-modal">
      <app-book-loader size="full" label="Processing payment…"></app-book-loader>
    </div>
  </div>
}

@if (orderSuccess(); as order) {
  <div class="modal-overlay" (click)="closeSuccess()">
    <div class="modal payment-modal" (click)="$event.stopPropagation()" style="text-align:center;">
      <div class="success-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="32" height="32"><polyline points="20 6 9 17 4 12"/></svg>
      </div>
      <h3 class="modal-title" style="margin-top:1rem;">Booking Confirmed!</h3>
      <p class="modal-subtitle">Order <strong>{{ order.id }}</strong> placed successfully.</p>
      <div class="success-delivery-box">
        <span>Expected delivery: <strong>{{ order.delivery | date: 'mediumDate' }}</strong></span>
      </div>
      <div style="display:flex;gap:0.75rem;margin-top:1.5rem;">
        <button type="button" class="btn-outline" style="flex:1;" (click)="closeSuccess()">Continue Shopping</button>
        <button type="button" class="btn-primary" style="flex:1;" (click)="goToOrders()">View Orders</button>
      </div>
    </div>
  </div>
}
